import { Component, OnInit, Inject, ChangeDetectorRef, NgZone, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ProjectSalePlanningInfo } from '../model/projectsaleplanning.model'
import { ProjectSaleInfo } from '../model/projectsale.model'
import { EmpInfo } from '../model/emp.model';
import { FormBuilder, FormGroup, FormArray, Validators, AbstractControl, FormControl, Form } from '@angular/forms';
import { GlobalService } from '../service/global.service';
import { Observable, Subject } from 'rxjs';
import {
  HttpEventType,
  HttpClient,
  HttpHeaders
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';
import { data } from 'jquery';
import { NgModule } from '@angular/core';
import { Calendar, CalendarOptions, EventApi, FullCalendarComponent } from '@fullcalendar/angular'; // useful for typechecking
import { ActivatedRoute } from '@angular/router';
import { TokenService } from '../service/token.service';
import { MapsAPILoader } from '@agm/core';
import { SaleTeamMappingEmployeeInfo } from '../model/SaleTeamMappingEmployeeInfo.model';
import { LookupInfo } from '../model/lookup.model';
import { ProjectPipelineInfo } from '../model/projectpipeline.model';
import { GraphMeetingInfo } from '../model/GraphMeetingInfo.model';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult, InteractionRequiredAuthError } from '@azure/msal-browser';
import { takeUntil } from 'rxjs/operators';

let today = new Date().toISOString()

@Component({
  selector: 'app-sale-planning',
  templateUrl: './sale-planning.component.html',
  styleUrls: ['./sale-planning.component.css']
})
export class SalePlanningComponent implements OnInit, AfterViewInit {

  displayloading: boolean = false;
  Msgloadding: string = '';
  public body: string;
  ProjectSalePlanningListPromise: Promise<ProjectSalePlanningInfo[]>
  ProjectSalePlanningList: ProjectSalePlanningInfo[] = []
  strJsonProjectSalePlanningList: string;
  ProjectSalePlanningPromisereturn: Promise<ProjectSalePlanningInfo[]>[] = []
  ProjectSaleListPromise: Promise<ProjectSaleInfo[]>
  ProjectSaleList: ProjectSaleInfo[] = []
  ProjectSaleListPromisereturn: Promise<ProjectSaleInfo[]>[] = []
  empList: EmpInfo[] = []
  empListLoad: EmpInfo[] = []
  empListPromise: Promise<EmpInfo[]>
  empListPromiseReturn: Promise<EmpInfo[]>
  calendarOptions: CalendarOptions

  fullCalendarInitialDate: string;

  txtSearch: string
  txtSearchDate: string
  txtSearchEndDate: string
  txtPlanningSubject: string
  ddlProjectSaleCode: string
  txtPlanningStartDate: string
  txtPlanningStartTime: string
  txtPlanningStartTimeAllday: string
  txtPlanningEndDate: string
  txtPlanningEndTime: string
  txtPlanningEndTimeAllday: string
  txtLocation: string
  txtDescription: string
  txtFlagAllDay: boolean
  _SelectedPlanEmpCode: string;
  ddlSaleTeamCode: string;
  ddlPlanType: string;
  txtPipelineStatusName: string;
  txtFlagCreateMSMeeting: boolean
  AttendeesEmail: string

  flagduplicate: boolean;
  hidProjectSaleId: number

  public empcodeinit: string
  hidebutton: Boolean;
  assignflag: boolean;
  viewflag: boolean;
  saleorglevelmax: number;
  saleorglevelemplogin: number;
  hidProjectSalePlanningId: number;

  public currentPageNumber: number
  public totalPages: number
  ProjectTotal: any
  EmpTotal: any
  isOnUpdate: boolean;
  isSubmitted: any;

  public totalActive: number
  public totalInActive: number
  public totalHold: number
  public totalClosed: number

  element: HTMLElement;
  public hidcouchk: number;
  public countall: number;

  CurrentYear: number;
  CurrentMonth: string;


  txtSearchSaleTeam: string = null;
  txtSearchSaleTeamMember: string = null;
  SaleTeamList: SaleTeamMappingEmployeeInfo[] = [];
  SaleTeamUnderList: SaleTeamMappingEmployeeInfo[] = [];
  PlanTypeList: LookupInfo[] = [];
  EmployeeList: EmpInfo[] = [];

  // Form Group
  ProjectSalePlanningForm: FormGroup;

  baseurl: string;
  getreturn: Promise<string>;
  monthNameslist: any;
  yearlist: any[] = [];

  _ForK2: string;
  _EmpCode: string;
  _ParamEmpCode: string;

  /****** Google map variables ******/
  lat: number = 13.7563;
  lng: number = 100.5018;
  zoom: number = 15;
  address: string;
  private geoCoder;
  @ViewChild('search') public searchElementRef: ElementRef;
  @ViewChild('searchedit') public searchEditElementRef: ElementRef;

  // Cache for employee colors to ensure consistency across the application
  employeeColorCache = {};

  // Cache for team colors to ensure consistency across the application
  teamColorCache = {};

  MyEmployeeNameWithUnder: string = '';
  pipelineStatusCodeSelected: string = '';
  pipelineStatusCodeSelectedUpd: string = '';
  isRequiredSaleTeam: boolean = false;
  isRequiredProjectSale: boolean = false;
  showLeadName: boolean = true;

  // Get employee-specific styles for use in the HTML template
  getEmployeeStyles(empCode: string) {
    if (!empCode) empCode = 'unknown';
    
    // Get or generate color for this employee
    let colorSet;
    if (this.employeeColorCache[empCode]) {
      colorSet = this.employeeColorCache[empCode];
    } else {
      colorSet = this.generateUniqueColorForEmployee(empCode);
      this.employeeColorCache[empCode] = colorSet;
    }
    
    return {
      'background-color': colorSet.backgroundColor,
      'border-color': colorSet.borderColor,
      'color': colorSet.textColor
    };
  }

  // Get employee-specific CSS class for text color
  getEmployeeTextClass(empCode: string) {
    if (!empCode) empCode = 'unknown';
    
    // Get or generate color for this employee
    let colorSet;
    if (this.employeeColorCache[empCode]) {
      colorSet = this.employeeColorCache[empCode];
    } else {
      colorSet = this.generateUniqueColorForEmployee(empCode);
      this.employeeColorCache[empCode] = colorSet;
    }
    
    return { 'color': colorSet.textColor };
  }

  // Get team-specific styles for use in the HTML template
  getTeamStyles(teamCode: string) {
    if (!teamCode) teamCode = 'unknown';
    
    // Get or generate color for this team
    let colorSet;
    if (this.teamColorCache[teamCode]) {
      colorSet = this.teamColorCache[teamCode];
    } else {
      colorSet = this.generateUniqueColorForTeam(teamCode);
      this.teamColorCache[teamCode] = colorSet;
    }
    
    return {
      'background-color': colorSet.backgroundColor,
      'border-color': colorSet.borderColor,
      'color': colorSet.textColor
    };
  }

  // Get team-specific CSS class for text color
  getTeamTextClass(teamCode: string) {
    if (!teamCode) teamCode = 'unknown';
    
    // Get or generate color for this team
    let colorSet;
    if (this.teamColorCache[teamCode]) {
      colorSet = this.teamColorCache[teamCode];
    } else {
      colorSet = this.generateUniqueColorForTeam(teamCode);
      this.teamColorCache[teamCode] = colorSet;
    }
    
    return { 'color': colorSet.textColor };
  }

  destroy$ = new Subject<void>();
  isSuccess: boolean = false;
  statusMessage: string | null = null;
  hidMeetingID: string = "";

  // Modal Employee for AttendeesEmail Select Zone
  IsHasMSAccount: boolean = false;
  @ViewChild('chkAllEmployee', { static: false }) chkAllEmployee: ElementRef;
  currentPageNumberEmployee: number = 1;
  totalItems: number = 0
  totalPagesEmployee: number

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService,
    private activatedRoute: ActivatedRoute, private cd: ChangeDetectorRef, private TokenService: TokenService, private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone, private msalService: MsalService) {
    this.baseurl = environment.base_api;

    this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    this._ParamEmpCode = this.activatedRoute.snapshot.params.EmpCode;
  }

  async ngOnInit() {
    // Get Msal access token
    const account = this.msalService.instance.getActiveAccount();
    //console.log('msal account', account);

    if (!account) {
      console.warn('No active account found! Redirect to login if needed.');
      // คุณอาจเรียก this.msalService.loginRedirect() หรือแสดงปุ่ม login
    }

    // ดึง Access Token แบบ Silent (handle refresh token อัตโนมัติ จาก Msal Service)
    this.getAccessToken(account)
      .then(token => {
        //console.log('Access Token:', token);
        this.callGraphApi(token);
    })
    .catch(err => {
      console.error('Failed to acquire token silently:', err);
      // Case silently error อาจเรียก this.msalService.acquireTokenRedirect({scopes: [...]}) 
    });

    this.ProjectSalePlanningForm = this.formBuilder.group({
      ddlProjectSaleCode: [null],
      txtPlanningSubject: [null, Validators.required],
      txtPlanningStartDate: [null, Validators.required],
      txtPlanningStartTime: [null],
      txtPlanningStartTimeAllday: [null],
      txtPlanningEndDate: [null, Validators.required],
      txtPlanningEndTime: [null],
      txtPlanningEndTimeAllday: [null],
      txtLocation: [null],
      txtFlagAllDay: [false],
      txtDescription: [null],
      ddlSaleTeamCode: [null, Validators.required],
      ddlPlanType: [null, Validators.required],
      txtPipelineStatusName: [null],
      txtFlagCreateMSMeeting: [false],
      AttendeesEmail: [null]
    });

    

  this.ProjectSalePlanningForm.get('ddlPlanType')?.valueChanges.subscribe(planType => {

  console.log('PlanType changed:', planType);

    if (planType === '2') {
      this.isRequiredSaleTeam = true;
      this.isRequiredProjectSale = true;
      this.showLeadName = true;

      this.ProjectSalePlanningForm.get('ddlProjectSaleCode')?.setValidators(Validators.required);
      this.ProjectSalePlanningForm.get('ddlSaleTeamCode')?.setValidators(Validators.required);
    } else {
      this.isRequiredSaleTeam = false;
      this.isRequiredProjectSale = false;
      this.showLeadName = false;

      this.ProjectSalePlanningForm.get('ddlProjectSaleCode')?.clearValidators();
      this.ProjectSalePlanningForm.get('ddlSaleTeamCode')?.clearValidators();
    }
    this.ProjectSalePlanningForm.get('ddlProjectSaleCode')?.updateValueAndValidity();
    this.ProjectSalePlanningForm.get('ddlSaleTeamCode')?.updateValueAndValidity();

    console.log('ddlProjectSaleCode validators:', this.ProjectSalePlanningForm.get('ddlProjectSaleCode')?.validator);
  console.log('ddlSaleTeamCode validators:', this.ProjectSalePlanningForm.get('ddlSaleTeamCode')?.validator);
  });

    this._EmpCode = !!this._ParamEmpCode ? this._ParamEmpCode : localStorage.getItem("EmpCode");

    console.log('Prepare load plantype')
    await this.LoadPlanType();

    this.currentPageNumberEmployee = 1;
    await this.LoadEmployeeList();

    // load check list task
    var d = new Date();
    //var today = new Date().toLocaleDateString('en-CA');

    this.txtSearch = (d.getFullYear() + '-' + (d.getMonth() + 1).toString().padStart(2, '0')) //Value for control
    this.txtSearchDate = d.getFullYear() + '-' + (d.getMonth() + 1).toString().padStart(2, '0') + '-01'; //Model to search
    var days = new Date(d.getFullYear(), (d.getMonth() + 1), 0).getDate();
    var enddate = d.getFullYear() + '-' + (d.getMonth() + 1).toString().padStart(2, '0') + '-' + days;
    this.txtSearchEndDate = enddate;

    //Load ddl sale team
    await this.LoadSaleTeam().then(async () => {
      await this.LoadPlanningList(true);

      this.ChangeEmpPlan(false);
    });

    //Load ddl project sale
    //this.LoadProjectSaleList();

    //Google map
    var that = this;
    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();
      this.geoCoder = new google.maps.Geocoder;

      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          that.address = place.formatted_address;
          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          //set latitude, longitude and zoom
          this.lat = place.geometry.location.lat();
          this.lng = place.geometry.location.lng();
          this.zoom = 12;
        });
      });

      let autocompleteEdit = new google.maps.places.Autocomplete(this.searchEditElementRef.nativeElement);
      autocompleteEdit.addListener("place_changed", () => {
        this.ngZone.run(() => {
          
          //get the place result
          let place: google.maps.places.PlaceResult = autocompleteEdit.getPlace();

          that.address = place.formatted_address;
          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          //set latitude, longitude and zoom
          this.lat = place.geometry.location.lat();
          this.lng = place.geometry.location.lng();
          this.zoom = 12;
        });
      });
    });
  }

  ngAfterViewInit(): void {
    // Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    var that = this;
    setTimeout(() => {
      $('.fc-toolbar-chunk').ready(function () {

        $('.fc-prev-button').on('click', x => {
          // Always go to month view first if we're not already in month view
          if (that.calendarComponent && that.calendarComponent.getApi().view.type !== 'dayGridMonth') {
            that.goToMonthView();
            return; // Exit early to prevent double processing
          }else{
            $("#app").html("");
          }

          console.log(this.txtSearchDate);
          var d = new Date($('#txtSearchDate').val() + '-01');
          var newDate = new Date(d.setMonth(d.getMonth() - 1));
          $('#txtSearchDate').val(newDate.getFullYear() + '-' + (newDate.getMonth() + 1).toString().padStart(2, '0'))
          that.txtSearchDate = newDate.toLocaleDateString('en-CA');
          var days = new Date(newDate.getFullYear(), (newDate.getMonth() + 1), 0).getDate();
          var enddate = newDate.getFullYear() + '-' + (newDate.getMonth() + 1).toString().padStart(2, '0') + '-' + days;
          that.txtSearchEndDate = enddate;

          that.LoadPlanningList(true);
        });
        $('.fc-next-button').on('click', x => {
          // Always go to month view first if we're not already in month view
          if (that.calendarComponent && that.calendarComponent.getApi().view.type !== 'dayGridMonth') {
            that.goToMonthView();
            return; // Exit early to prevent double processing
          }else{
            $("#app").html("");
          }

          console.log(this.txtSearchDate);
          var d = new Date($('#txtSearchDate').val() + '-01');
          var newDate = new Date(d.setMonth(d.getMonth() + 1));
          $('#txtSearchDate').val(newDate.getFullYear() + '-' + (newDate.getMonth() + 1).toString().padStart(2, '0'))

          that.txtSearchDate = newDate.toLocaleDateString('en-CA');
          var days = new Date(newDate.getFullYear(), (newDate.getMonth() + 1), 0).getDate();
          var enddate = newDate.getFullYear() + '-' + (newDate.getMonth() + 1).toString().padStart(2, '0') + '-' + days;
          that.txtSearchEndDate = enddate;
          that.LoadPlanningList(true);
        });
        $('.fc-today-button').on('click', x => {
          // Always go to month view first if we're not already in month view
          if (that.calendarComponent && that.calendarComponent.getApi().view.type !== 'dayGridMonth') {
            that.goToMonthView();
            return; // Exit early to prevent double processing
          }else{
            $("#app").html("");
          }

          console.log(this.txtSearchDate);
          var d = new Date();
          var newDate = new Date(d.setDate(1));
          $('#txtSearchDate').val(newDate.getFullYear() + '-' + (newDate.getMonth() + 1).toString().padStart(2, '0'))

          that.txtSearchDate = newDate.toLocaleDateString('en-CA');
          var days = new Date(newDate.getFullYear(), (newDate.getMonth() + 1), 0).getDate();
          var enddate = newDate.getFullYear() + '-' + (newDate.getMonth() + 1).toString().padStart(2, '0') + '-' + days;
          that.txtSearchEndDate = enddate;
          that.LoadPlanningList(true);
        });
        
      });
    }, 1500);
  }

  async LoadProjectSaleList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectSaleCurrentEmpCode'] = this.checkUndefinedString(this._SelectedPlanEmpCode ? this._SelectedPlanEmpCode : this._EmpCode);
      //objectjson['ProjectSaleTeamCode'] = this.checkUndefinedString(this.ddlSaleTeamCode) ? this.ddlSaleTeamCode : null;
      objectjson['ProjectSaleTeamCode'] = this.ProjectSalePlanningForm.get('ddlSaleTeamCode').value
      objectjson['ProjectSaleFlagDelete'] = "N";
      let strjson = JSON.stringify(objectjson);

      //this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetProjectSale", strjson, httpOptions)
      //.toPromise().then((data) => {
      //    this.ProjectSaleList = data
      //});

        try {
      const data = await this.httpClient
        .post<ProjectSaleInfo[]>(this.baseurl + 'ProjectSale/GetProjectSale', strjson, httpOptions)
        .toPromise();

      this.ProjectSaleList = data;
        } catch (error) {
      console.error('LoadProjectSaleList error:', error);
      }
    }
  }

  async LoadProjectSalePlanningList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['CreateBy'] = this.checkUndefinedString(this.txtSearchSaleTeamMember) ? this.txtSearchSaleTeamMember : null
      objectjson['StartDate'] = this.txtSearchDate;
      objectjson['EndDate'] = this.txtSearchEndDate;
      objectjson['ProjectSaleFlagDelete'] = "N";
      objectjson['ProjectSaleTeamCode'] = this.checkUndefinedString(this.txtSearchSaleTeam) ? this.txtSearchSaleTeam : null;
      if(this.txtSearchSaleTeamMember == null) objectjson['AllUnderEmpCode'] = this._EmpCode;

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<any>(this.baseurl + "ProjectSalePlanning/GetProjectSalePlanning", strjson, httpOptions)
        .toPromise();
    }
  }

  async btnClick_submitInsertPlanning() {
    
    //console.log(this.ProjectSalePlanningForm);
    if (this.ProjectSalePlanningForm.valid) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.OnCreating('y');
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['Subject'] = this.ProjectSalePlanningForm.get('txtPlanningSubject').value
        objectjson['ProjectSaleCode'] = this.ProjectSalePlanningForm.get('ddlProjectSaleCode').value
        objectjson['Description'] = this.checkUndefinedString(this.ProjectSalePlanningForm.get('txtDescription').value)
        if (objectjson['FlagAllDay'] = this.ProjectSalePlanningForm.get('txtFlagAllDay').value == false) {
          objectjson['StartDate'] = this.checkUndefinedDate(this.ProjectSalePlanningForm.get('txtPlanningStartDate').value) + "T" + this.checkUndefinedString(this.ProjectSalePlanningForm.get('txtPlanningStartTime').value) + ":00"
          objectjson['EndDate'] = this.checkUndefinedDate(this.ProjectSalePlanningForm.get('txtPlanningEndDate').value) + "T" + this.checkUndefinedString(this.ProjectSalePlanningForm.get('txtPlanningEndTime').value) + ":00"
        } else if (this.ProjectSalePlanningForm.get('txtFlagAllDay').value == true) {
          objectjson['StartDate'] = this.checkUndefinedDate(this.ProjectSalePlanningForm.get('txtPlanningStartDate').value) + "T00:00:00";
          objectjson['EndDate'] = this.checkUndefinedDate(this.ProjectSalePlanningForm.get('txtPlanningEndDate').value) + "T00:00:00";
        }
        objectjson['CreateBy'] = this.checkUndefinedString(this._EmpCode)
        objectjson['FlagAllDay'] = this.ProjectSalePlanningForm.get('txtFlagAllDay').value ? 'Y' : 'N'
        objectjson['FlagDelete'] = "N";
        objectjson['Address'] = this.address;
        objectjson['Latitude'] = this.lat;
        objectjson['Longitude'] = this.lng;
        objectjson['PlanType'] = this.checkUndefinedString(this.ProjectSalePlanningForm.get('ddlPlanType').value)
        objectjson['PipelineStatus'] = this.checkUndefinedString(this.pipelineStatusCodeSelected)
        objectjson['ProjectSaleTeamCode'] = this.ProjectSalePlanningForm.get('ddlSaleTeamCode').value
        objectjson['MeetingTeamFlag'] = this.ProjectSalePlanningForm.get('txtFlagCreateMSMeeting')?.value ? 'Y' : 'N';
        objectjson['AttendeesEmail'] = this.ProjectSalePlanningForm.get('AttendeesEmail')?.value || '';

        if (this.ProjectSalePlanningForm.get('txtFlagCreateMSMeeting').value == true) {
          const meetingId = await this.createTeamsMeeting();
            if (meetingId) {
              objectjson['MeetingTeamID'] = meetingId;
            } else {
              console.error("Cannot Insert Microsoft Teams Meeting");
          }
        }

        let strjson = JSON.stringify(objectjson);
        console.log(strjson);
        this.isSubmitted = this.httpClient.post<ProjectSalePlanningInfo[]>(this.baseurl + "ProjectSalePlanning/InsertProjectSalePlanning", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Insert fail")
            this.OnCreating('n');
          },
            async () => {
              console.log("Insert = " + this.isSubmitted)
              this.OnCreating('n');
              this.txtSearchDate = "";
              $('#ModalCreateComplate').modal();
              this.ngOnInit();
            }
          );
      }
    } else {
      
      this.GlobalService.validateAllFormFields(this.ProjectSalePlanningForm);
      $('.ng-invalid')[0].focus()
    }

  }

  async btnClick_submitUpdatePlanning(id) {
    $('#modalProjectSalePlanningEdit').modal('hide');
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.OnUpdating('y');
      id = this.hidProjectSalePlanningId
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      this.ProjectSalePlanningForm.patchValue({
        txtPlanningSubject: this.txtPlanningSubject,
        txtPlanningStartDate: this.txtPlanningStartDate,
        txtPlanningStartTime: this.txtPlanningStartTime,
        txtPlanningEndDate: this.txtPlanningEndDate,
        txtPlanningEndTime: this.txtPlanningEndTime
      });

      var objectjson = {};
      objectjson['ProjectSalePlanningId'] = id;
      objectjson['Subject'] = this.txtPlanningSubject;
      objectjson['ProjectSaleCode'] = this.ddlProjectSaleCode;
      objectjson['Description'] = this.checkUndefinedString(this.txtDescription)
      if (objectjson['FlagAllDay'] = this.txtFlagAllDay == false) {
        objectjson['StartDate'] = this.checkUndefinedDate(this.txtPlanningStartDate) + "T" + this.checkUndefinedString(this.txtPlanningStartTime) + ":00"
        objectjson['EndDate'] = this.checkUndefinedDate(this.txtPlanningEndDate) + "T" + this.checkUndefinedString(this.txtPlanningEndTime) + ":00"
      } else if (this.txtFlagAllDay == true) {
        objectjson['StartDate'] = this.checkUndefinedDate(this.txtPlanningStartDate) + "T00:00:00";
        objectjson['EndDate'] = this.checkUndefinedDate(this.txtPlanningEndDate) + "T00:00:00";
        }
      objectjson['UpdateBy'] = this.checkUndefinedString(this._EmpCode)
      objectjson['FlagAllDay'] = this.txtFlagAllDay ? 'Y' : 'N'
      objectjson['FlagDelete'] = "N";
      objectjson['Address'] = this.address;
      objectjson['Latitude'] = this.lat;
      objectjson['Longitude'] = this.lng;
      objectjson['PlanType'] = this.checkUndefinedString(this.ProjectSalePlanningForm.get('ddlPlanType').value);
      objectjson['PipelineStatus'] = this.checkUndefinedString(this.pipelineStatusCodeSelectedUpd);
      objectjson['ProjectSaleTeamCode'] = this.checkUndefinedString(this.ProjectSalePlanningForm.get('ddlSaleTeamCode').value);

      objectjson['MeetingTeamID'] = this.hidMeetingID;
      objectjson['MeetingTeamFlag'] = this.ProjectSalePlanningForm.get('txtFlagCreateMSMeeting')?.value ? 'Y' : 'N';
      objectjson['AttendeesEmail'] = this.ProjectSalePlanningForm.get('AttendeesEmail')?.value || '';

      console.log('meetingflag before update!!', this.ProjectSalePlanningForm.get('txtFlagCreateMSMeeting').value);

        if (this.ProjectSalePlanningForm.get('txtFlagCreateMSMeeting').value == true) {
          console.log('update meeting from ID', this.hidMeetingID);
          if (this.hidMeetingID) {
            // Update Meeting
            const updatedMeetingId = await this.updateTeamsMeeting(this.hidMeetingID);
              if (updatedMeetingId) {
                objectjson['MeetingTeamID'] = updatedMeetingId;
              } else {
                console.error("Cannot update Microsoft Teams Meeting");
            }
          } else {
          // Create Meeting No have meetingID
            const meetingId = await this.createTeamsMeeting();
              if (meetingId) {
                objectjson['MeetingTeamID'] = meetingId;
              } else {
              console.error("Cannot create Microsoft Teams Meeting");
              }
            }
        }
        else {
          //console.log('delete meeting from ID', this.hidMeetingID);
          await this.deleteTeamsMeeting(this.hidMeetingID);
          objectjson['MeetingTeamFlag'] = "N";
        }

      let strjson = JSON.stringify(objectjson);

      this.isSubmitted = this.httpClient.post<ProjectSalePlanningInfo[]>(this.baseurl + "ProjectSalePlanning/UpdateProjectSalePlanning", strjson, httpOptions)

        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("Update fail")
          this.OnUpdating('n');
        },
          () => {
            console.log("Update = " + this.isSubmitted)
            this.OnUpdating('n');
            this.txtSearchDate = "";
            $('#ModalUpdateComplate').modal();
            this.ngOnInit();
          }
        );
    }
  }

  async btnClick_submitDeletePlanning() {
    var id = parseInt($('#hdfPlanId').val().toString());

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['ProjectSalePlanningId'] = id;

      let strjsonCusInfo = JSON.stringify(objectjson);

      this.httpClient.post<ProjectSalePlanningInfo[]>(this.baseurl + "ProjectSalePlanning/DeleteProjectSalePlanning", strjsonCusInfo, httpOptions)
        .toPromise()
        .then(
          data => {
            this.deleteTeamsMeeting(this.hidMeetingID);
            $('#ModalDeleteConfirm').modal('hide');
            $('#ModalDeleteComplate').modal('show');
            this.LoadPlanningList(true);
          }
        );
    }

  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }

  checkUndefinedDate(strInput: string) {
    if (strInput === undefined || strInput === null || strInput === '') {
      strInput = null
    }
    return strInput

  }

  isFieldValid(field: string) {
    return !this.ProjectSalePlanningForm.get(field).valid && this.ProjectSalePlanningForm.get(field).touched;
  }

  async btnClick_onCreateSalePlanning() {
    this._SelectedPlanEmpCode = null;
    //this.LoadProjectSaleList();
    this.setCurrentLocation();
    this.isOnUpdate = false
    this.address = "";
    this.ProjectSalePlanningForm.reset();
    this.ProjectSalePlanningForm.markAsUntouched()
    this.ProjectSalePlanningForm.patchValue({
      txtFlagAllDay: false,
      txtFlagCreateMSMeeting: true
    });

    if (this.PlanTypeList && this.PlanTypeList.length > 0) {

      

      const defaultPlanType = this.PlanTypeList[0].LookupCode;
      const defaultSaleTeamCode = this.SaleTeamList?.[0]?.SaleTeamCode ?? null;

      this.ProjectSalePlanningForm.patchValue({
      ddlPlanType: defaultPlanType,
      ddlSaleTeamCode: defaultSaleTeamCode
    });
  }

  const account = this.msalService.instance.getActiveAccount();
  this.IsHasMSAccount = !!account;
  if (!account) {
    //console.log("No Microsoft account found, redirecting to login...");
    const confirmLogin = window.confirm("คุณต้องการ login Microsoft เพื่อสร้าง Teams Meeting หรือไม่?");

    if (confirmLogin) {
      this.msalService.loginRedirect({
      scopes: ['User.Read', 'Calendars.ReadWrite', "Mail.ReadWrite", "Mail.Send", 'OnlineMeetings.ReadWrite'],
      prompt: 'login'
    });
      return; // ยังไม่ให้เปิด modal จนกว่าจะ login
    } else {
      this.IsHasMSAccount = false;
      this.ProjectSalePlanningForm.patchValue({txtFlagCreateMSMeeting: false});
      //console.log("User chose not to login Microsoft");
    }
  } else {
    try {
      // มี account แล้ว → เช็กว่า token ยังใช้ได้ไหม
      await this.msalService.instance.acquireTokenSilent({
        scopes: [
          'User.Read',
          'Mail.ReadWrite',
          'Mail.Send',
          'Calendars.ReadWrite',
          'OnlineMeetings.ReadWrite'
        ],
        account: account
      });
      //console.log('Microsoft session ready');
    } catch (err) {
      console.warn('Token invalid or expired, redirecting login...', err);

      if (err instanceof InteractionRequiredAuthError) {
        alert("Session Microsoft ของคุณหมดอายุ ต้อง login ใหม่เพื่อใช้งาน Teams Meeting");
        this.msalService.loginRedirect({
          scopes: [
            'User.Read',
            'Mail.ReadWrite',
            'Mail.Send',
            'Calendars.ReadWrite',
            'OnlineMeetings.ReadWrite'
          ],
          prompt: 'login'
        });
        return;
      } else {
        alert('ไม่สามารถตรวจสอบ session ของ Microsoft ได้ กรุณาลองใหม่');
        return;
      }
    }
  }

    $('#ddlProjectSaleCode').removeAttr('disabled');
    $('#modalProjectSalePlanningController').modal('show'); 
  }
  CheckduplicateProjectSaleCode() {
    if (this.isOnUpdate == true) {
      return false;
    }

    var ProjectSaleCode = this.ddlProjectSaleCode;
    let index = this.ProjectSalePlanningList.findIndex(x => x.ProjectSaleCode == ProjectSaleCode);
    var flagreturn = false;
    if (index != -1) {
      flagreturn = true;
    }
    this.flagduplicate = flagreturn;
    return flagreturn;
  }
  async btnClick_onUpdateSalePlanning(id) {
    

    $('#modalProjectSalePlanningController').modal('hide');
    this.txtPlanningStartTimeAllday = "00:00";
    this.txtPlanningEndTimeAllday = "00:00";
    this.isOnUpdate = true

    let index = this.ProjectSalePlanningList.findIndex(x => x.ProjectSalePlanningId == id);
    let item = this.ProjectSalePlanningList[index];
    this.ProjectSalePlanningForm.patchValue({
      txtFlagAllDay: false,
      ddlPlanType: item.PlanType || null,
      ddlSaleTeamCode: item.ProjectSaleTeamCode || null,
      txtPipelineStatusName: item.PipelineStatus || null,
      txtFlagCreateMSMeeting: false,
      AttendeesEmail: item.AttendeesEmail || null
    });

    const pipelineStatusCode = this.ProjectSalePlanningForm.get('txtPipelineStatusName')?.value;
    this.pipelineStatusCodeSelectedUpd = pipelineStatusCode;
    const statusName = await this.GetPipelineStatusName(pipelineStatusCode);

    this.ProjectSalePlanningForm.patchValue({ txtPipelineStatusName: statusName || null});

    this._SelectedPlanEmpCode = this.ProjectSalePlanningList[index].CreateBy;

    await this.LoadProjectSaleList();
    this.ProjectSalePlanningForm.patchValue({
    ddlProjectSaleCode: item.ProjectSaleCode || null
    });
    //this.LoadProjectSaleList();

    this.ddlProjectSaleCode = this.ProjectSalePlanningList[index].ProjectSaleCode != null ? this.ProjectSalePlanningList[index].ProjectSaleCode : null
    this.txtPlanningSubject = this.ProjectSalePlanningList[index].Subject != null ? this.ProjectSalePlanningList[index].Subject : null
    this.txtPlanningStartDate = this.ProjectSalePlanningList[index].StartDate != null ? this.GlobalService.formatDate(this.ProjectSalePlanningList[index].StartDate) : null
    this.txtPlanningStartTime = this.ProjectSalePlanningList[index].StartDate != null ? this.GlobalService.formatTime(this.ProjectSalePlanningList[index].StartDate) : null
    this.txtPlanningEndDate = this.ProjectSalePlanningList[index].EndDate != null ? this.GlobalService.formatDate(this.ProjectSalePlanningList[index].EndDate) : null
    this.txtPlanningEndTime = this.ProjectSalePlanningList[index].EndDate != null ? this.GlobalService.formatTime(this.ProjectSalePlanningList[index].EndDate) : null

    this.txtPlanningStartTimeAllday = "00:00:00"
    this.txtPlanningEndTimeAllday = "00:00:00"

    this.txtFlagAllDay = !!this.ProjectSalePlanningList[index].FlagAllDay ? (this.ProjectSalePlanningList[index].FlagAllDay == 'Y' ? true : false) : false;
    this.address = this.ProjectSalePlanningList[index].Address != null ? this.ProjectSalePlanningList[index].Address : null
    this.txtDescription = this.ProjectSalePlanningList[index].Description != null ? this.ProjectSalePlanningList[index].Description : null
    this.hidProjectSalePlanningId = this.ProjectSalePlanningList[index].ProjectSalePlanningId

    this.address = this.ProjectSalePlanningList[index].Address;
    this.lat = Number(this.ProjectSalePlanningList[index].Latitude);
    this.lng = Number(this.ProjectSalePlanningList[index].Longitude);

    const meetingFlag = this.ProjectSalePlanningList[index].MeetingTeamFlag === 'Y';
    this.ProjectSalePlanningForm.get('txtFlagCreateMSMeeting')?.setValue(meetingFlag);

    this.hidMeetingID = this.ProjectSalePlanningList[index].MeetingTeamID;

    //console.log('MeetingID:', this.hidMeetingID);
    //console.log('MeetingTeamFlag', this.ProjectSalePlanningForm.get('txtFlagCreateMSMeeting').value)
    //console.log('txtPlanningStartDate', this.txtPlanningStartDate);
    //console.log('txtPlanningStartTime', this.txtPlanningStartTime);
    //console.log('txtPlanningEndDate', this.txtPlanningEndDate);
    //console.log('txtPlanningEndTime', this.txtPlanningEndTime);

    this.ProjectSalePlanningForm.patchValue({
      txtPlanningStartDate: this.txtPlanningStartDate,
      txtPlanningStartTime: this.txtPlanningStartTime,
      txtPlanningEndDate: this.txtPlanningEndDate,
      txtPlanningEndTime: this.txtPlanningEndTime
    });

    const account = this.msalService.instance.getActiveAccount();
    this.IsHasMSAccount = !!account;
  if (!account) {
    //console.log("No Microsoft account found, redirecting to login...");
    const confirmLogin = window.confirm("คุณต้องการ login Microsoft เพื่อสร้างหรือเปลี่ยนแปลงในการจัดการ Microsoft Teams Meeting หรือไม่?");

    if (confirmLogin) {
      this.msalService.loginRedirect({
      scopes: ['User.Read', "Mail.ReadWrite", "Mail.Send", 'Calendars.ReadWrite', 'OnlineMeetings.ReadWrite'],
      prompt: 'login'
    });
      return; // ยังไม่ให้เปิด modal จนกว่าจะ login
    } else {
      this.IsHasMSAccount = false;
      //console.log("User chose not to login Microsoft");
    }
  } else {
        try {
            await this.msalService.instance.acquireTokenSilent({
                scopes: ['User.Read', "Mail.ReadWrite", "Mail.Send", 'Calendars.ReadWrite', 'OnlineMeetings.ReadWrite'],
                account: account
            });
            //console.log('Microsoft session ready');
        } catch (err) {
            console.warn('Token invalid or expired, redirecting login...', err);
            if (err instanceof InteractionRequiredAuthError) {
                alert("Session Microsoft ของคุณหมดอายุ ต้อง login ใหม่เพื่อใช้งาน Teams Meeting");
                this.msalService.loginRedirect({
                    scopes: ['User.Read', "Mail.ReadWrite", "Mail.Send", 'Calendars.ReadWrite', 'OnlineMeetings.ReadWrite'],
                    prompt: 'login'
                });
                return;
            } else {
                alert('ไม่สามารถตรวจสอบ session ของ Microsoft ได้ กรุณาลองใหม่');
                return;
            }
        }
    }

    $('#modalProjectSalePlanningEdit').modal();

  }
  async btnClick_onDeleteSalePlanning(id) {
    let index = this.ProjectSalePlanningList.findIndex(x => x.ProjectSalePlanningId == id);
    this.hidMeetingID = this.ProjectSalePlanningList[index].MeetingTeamID;
    //console.log('Delete MeetingID:', this.hidMeetingID);

    const account = this.msalService.instance.getActiveAccount();
    if (!account) {
      //console.log("No Microsoft account found, redirecting to login...");
      const confirmLogin = window.confirm("คุณต้องการ login Microsoft เพื่อให้สามารถเข้าถึงและลบ Microsoft Teams Meeting หรือไม่?");

    if (confirmLogin) {
      this.msalService.loginRedirect({
      scopes: ['User.Read', "Mail.ReadWrite", "Mail.Send", 'Calendars.ReadWrite', 'OnlineMeetings.ReadWrite'],
      prompt: 'login'
    });
      return; // ยังไม่ให้เปิด modal จนกว่าจะ login
    } else {
      //console.log("User chose not to login Microsoft");
      }
    } else {
      try {
        await this.msalService.instance.acquireTokenSilent({
            scopes: ['User.Read', "Mail.ReadWrite", "Mail.Send", 'Calendars.ReadWrite', 'OnlineMeetings.ReadWrite'],
            account: account
        });
        //console.log('Microsoft session ready');
    } catch (err) {
        if (err instanceof InteractionRequiredAuthError) {
            alert("Session Microsoft ของคุณหมดอายุ ต้อง login ใหม่เพื่อใช้งาน Teams Meeting");
            this.msalService.loginRedirect({
                scopes: ['User.Read', "Mail.ReadWrite", "Mail.Send", 'Calendars.ReadWrite', 'OnlineMeetings.ReadWrite'],
                prompt: 'login'
            });
            return;
        } else {
            alert('ไม่สามารถตรวจสอบ session ของ Microsoft ได้ กรุณาลองใหม่');
            return;
        }
      }
    }

    $('#hdfPlanId').val(id);
    $('#ModalDeleteConfirm').modal()
  }

  OnCreating(flag) {
    if (flag == 'y') {
      $("#loadingcreate").show();
      $("#btnsubmitplanning").hide();
      $("#txtPlanningSubject").prop('disabled', true);
      $("#txtPlanningStartDate").prop('disabled', true);
      $('#txtPlanningStartTime').prop('disabled', true);
      $('#txtPlanningStartTimeAllday').prop('disabled', true);
      $('#txtPlanningEndDate').prop('disabled', true);
      $('#txtPlanningEndTime').prop('disabled', true);
      $('#txtPlanningEndTimeAllday').prop('disabled', true);
      $("#txtFlagAllDay").prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingcreate").hide();
      $("#btnsubmitplanning").show();
      $("#txtPlanningSubject").removeAttr('disabled');
      $("#txtPlanningStartDate").removeAttr('disabled');
      $('#txtPlanningStartTime').removeAttr('disabled');
      $('#txtPlanningStartTimeAllday').removeAttr('disabled');
      $('#txtPlanningEndDate').removeAttr('disabled');
      $('#txtPlanningEndTime').removeAttr('disabled');
      $('#txtPlanningEndTimeAllday').removeAttr('disabled');
      $("#txtFlagAllDay").removeAttr('disabled');
      $('#modalProjectSalePlanningController').modal('hide');
    }

  }
  OnUpdating(flag) {
    if (flag == 'y') {
      $("#loadingcreate").show();
      $("#btnsubmitplanning").hide();
      $("#txtPlanningSubject").prop('disabled', true);
      $("#txtPlanningStartDate").prop('disabled', true);
      $('#txtPlanningStartTime').prop('disabled', true);
      $('#txtPlanningStartTimeAllday').prop('disabled', true);
      $('#txtPlanningEndDate').prop('disabled', true);
      $('#txtPlanningEndTime').prop('disabled', true);
      $('#txtPlanningEndTimeAllday').prop('disabled', true);
      $("#txtFlagAllDay").prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingcreate").hide();
      $("#btnsubmitplanning").show();
      $("#txtPlanningSubject").removeAttr('disabled');
      $("#txtPlanningStartDate").removeAttr('disabled');
      $('#txtPlanningStartTime').removeAttr('disabled');
      $('#txtPlanningStartTimeAllday').removeAttr('disabled');
      $('#txtPlanningEndDate').removeAttr('disabled');
      $('#txtPlanningEndTime').removeAttr('disabled');
      $('#txtPlanningEndTimeAllday').removeAttr('disabled');
      $("#txtFlagAllDay").removeAttr('disabled');
      $('#modalProjectSalePlanningController').modal('hide');
    }

  }

  //Google Map
  /*********************************************************/
  // Get Current Location Coordinates
  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.lat = position.coords.latitude;
        this.lng = position.coords.longitude;
        this.zoom = 15;
      });
    }
  }

  markerDragEnd($event: google.maps.MouseEvent) {
    console.log($event);
    if ($event) {
      this.lat = $event.latLng.lat();
      this.lng = $event.latLng.lng();
      this.getAddress(this.lat, this.lng);
    }
  }

  getAddress(latitude, longitude) {
    
    this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
      console.log(results);
      console.log(status);
      if (status === 'OK') {
        if (results[0]) {
          this.zoom = 12;
          
          this.address = results[0].formatted_address;
          $(this.searchElementRef.nativeElement).val("");

        } else {
          window.alert('No results found');
        }
      } else {
        window.alert('Geocoder failed due to: ' + status);
      }

    });
  }

  mapClicked($event: google.maps.MouseEvent) {
    if ($event) {
      this.lat = $event.latLng.lat();
      this.lng = $event.latLng.lng();
      this.getAddress(this.lat, this.lng);
    }
  }

  //Fullcalendar
  /*********************************************************/
  @ViewChild('calendar') calendarComponent: FullCalendarComponent;
  currentEvents: EventApi[] = [];
  calendarValues = {
    StartDate: "",
    EndDate: ""
  };

  fullcalendarLoadEvent(data) {
    var eventobjectarray = [];
    data.forEach((traget, indextraget) => {
      var eventlistobject = {};
      eventlistobject['title'] = traget.Subject;
      eventlistobject['date'] = traget.StartDate;
      eventlistobject['id'] = traget.ProjectSalePlanningId;

      // Get team code from the data
      const teamCode = traget.ProjectSaleTeamCode || 'unknown';
      
      // Get or generate color for this team
      let colorSet;
      if (this.teamColorCache[teamCode]) {
        colorSet = this.teamColorCache[teamCode];
      } else {
        colorSet = this.generateUniqueColorForTeam(teamCode);
        this.teamColorCache[teamCode] = colorSet;
      }

      // Apply colors to the event
      eventlistobject['backgroundColor'] = colorSet.backgroundColor;
      eventlistobject['borderColor'] = colorSet.borderColor;
      eventlistobject['textColor'] = colorSet.textColor;
      eventlistobject['textAlign'] = 'left';

      eventobjectarray.push(eventlistobject);
    });

    this.calendarOptions = {

      initialView: 'dayGridMonth',
      dayMaxEvents: true,
      events: eventobjectarray.reverse(),
      eventDisplay: 'block',
      eventColor: '#C4E1F3',
      eventBorderColor: '#205A7E',
      eventTextColor: '#000',
      displayEventTime: false,
      displayEventEnd: true,
      selectable: false,
      eventOrder: '-id',
      initialDate: this.fullCalendarInitialDate,
      initialEvents: eventobjectarray[0],
      height: '100%',
      dateClick: this.handleDateClick.bind(this), // bind is important!
      navLinks: false,
      dayCellClassNames: (arg) => {
        // Add a custom class to days outside the current month
        const date = arg.date;
        const currentMonth = new Date(this.txtSearchDate);
        if (date.getMonth() !== currentMonth.getMonth() || 
            date.getFullYear() !== currentMonth.getFullYear()) {
          return ['fc-day-other', 'fc-day-disabled'];
        }
        return [];
      },
      customButtons: {
        customBackButton: {
          text: 'Back',
          click: () => this.goToMonthView()
        }
      },
      headerToolbar: {
        left: 'title',
        center: '',
        right: 'today customBackButton'
      },
      viewDidMount: (view) => {
        // Find the prev/next buttons and add disabled class if needed
        const header = document.querySelector('.fc-header-toolbar');
        if (header) {
          const prevButton = header.querySelector('.fc-prev-button');
          const nextButton = header.querySelector('.fc-next-button');
          
          if (prevButton && this.isNavigationDisabled('prev')) {
            prevButton.classList.add('fc-button-disabled');
            prevButton.setAttribute('disabled', 'disabled');
          }
          
          if (nextButton && this.isNavigationDisabled('next')) {
            nextButton.classList.add('fc-button-disabled');
            nextButton.setAttribute('disabled', 'disabled');
          }
        }
      }
    }


  }


  isNavigationDisabled(direction: 'prev' | 'next'): boolean {
    const currentDate = new Date(this.txtSearchDate);
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();
    
    // Define your rules for disabling navigation
    // For example, disable if trying to go before current month or after next year
    if (direction === 'prev') {
      // Disable previous if it would go before current month
      // You can customize this logic based on your requirements
      return true; // Always disable prev
    } else if (direction === 'next') {
      // Disable next if it would go beyond a certain point
      // You can customize this logic based on your requirements
      return true; // Always disable next
    }
    
    return false;
  }


  generateUniqueColorForEmployee(empCode: string) {
    // If no employee code, use a default
    if (!empCode) return {
      backgroundColor: '#dee2e6',
      borderColor: '#6c757d',
      textColor: '#6c757d'
    };

    // Add salt to the employee code to make similar codes more differentiable
    // Using a fixed salt string plus the length of the code as additional entropy
    const salt = "POP-Calendar-Salt-" + empCode.length;
    const saltedEmpCode = empCode + salt;

    // Create a hash from the salted employee code
    let hash = 0;
    for (let i = 0; i < saltedEmpCode.length; i++) {
      hash = saltedEmpCode.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    // Add more entropy by using the original code's first and last characters
    if (empCode.length > 0) {
      hash += empCode.charCodeAt(0) * 17; // Multiply by a prime number
      hash += empCode.charCodeAt(empCode.length - 1) * 31; // Another prime
    }
    
    // Convert hash to a hue value (0-360)
    const hue = Math.abs(hash % 360);
    
    // Vary saturation and lightness slightly based on hash to further differentiate
    // This ensures even similar codes get different color characteristics
    const saturation = 65 + (Math.abs(hash) % 20); // 65-85% saturation
    const lightness = 60 + (Math.abs(hash >> 4) % 15); // 60-75% lightness
    
    return {
      backgroundColor: `hsla(${hue}, ${saturation}%, ${lightness}%, 0.3)`,
      borderColor: `hsl(${hue}, ${saturation}%, ${lightness - 25}%)`,
      textColor: `hsl(${hue}, ${saturation}%, ${lightness - 40}%)`
    };
  }

  generateUniqueColorForTeam(teamCode: string) {
    // If no team code, use a default
    if (!teamCode) return {
      backgroundColor: '#dee2e6',
      borderColor: '#6c757d',
      textColor: '#6c757d'
    };

    // Add salt to the team code to make similar codes more differentiable
    // Using a fixed salt string plus the length of the code as additional entropy
    const salt = "POP-Team-Salt-" + teamCode.length;
    const saltedTeamCode = teamCode + salt;

    // Create a hash from the salted team code
    let hash = 0;
    for (let i = 0; i < saltedTeamCode.length; i++) {
      hash = saltedTeamCode.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    // Add more entropy by using the original code's first and last characters
    if (teamCode.length > 0) {
      hash += teamCode.charCodeAt(0) * 17; // Multiply by a prime number
      hash += teamCode.charCodeAt(teamCode.length - 1) * 31; // Another prime
    }
    
    // Convert hash to a hue value (0-360)
    const hue = Math.abs(hash % 360);
    
    // Vary saturation and lightness slightly based on hash to further differentiate
    // This ensures even similar codes get different color characteristics
    const saturation = 65 + (Math.abs(hash) % 20); // 65-85% saturation
    const lightness = 60 + (Math.abs(hash >> 4) % 15); // 60-75% lightness
    
    return {
      backgroundColor: `hsla(${hue}, ${saturation}%, ${lightness}%, 0.3)`,
      borderColor: `hsl(${hue}, ${saturation}%, ${lightness - 25}%)`,
      textColor: `hsl(${hue}, ${saturation}%, ${lightness - 40}%)`
    };
  }

  goToMonthView() {
    this.calendarComponent.getApi().changeView('dayGridMonth');
    $("#app").html(""); // Clear the date display

    // // Set txtSearchDate to first day of current month
    // var d = new Date();
    // this.txtSearchDate = d.getFullYear() + '-' + (d.getMonth() + 1).toString().padStart(2, '0') + '-01';
    
    // // Set txtSearchEndDate to last day of current month
    // var lastDay = new Date(d.getFullYear(), d.getMonth() + 1, 0);
    // this.txtSearchEndDate = lastDay.getFullYear() + '-' + (lastDay.getMonth() + 1).toString().padStart(2, '0') + '-' + lastDay.getDate().toString().padStart(2, '0');


    var d = new Date(this.txtSearchDate);
    var days = new Date(d.getFullYear(), (d.getMonth() + 1), 0).getDate();
    var startDate = d.getFullYear() + '-' + (d.getMonth() + 1).toString().padStart(2, '0') + '-01';
    var endDate = d.getFullYear() + '-' + (d.getMonth() + 1).toString().padStart(2, '0') + '-' + days;
    this.txtSearchEndDate = endDate;
    this.txtSearchDate = startDate;

    // Reload planning list for current month
    this.LoadPlanningList(true);
  }

  handleEvents(events: EventApi[]) {
    this.currentEvents = events;
  }

  handleDateClick(arg, traget, event) {

    // Check if the clicked date is in the current month
    const clickedDate = new Date(arg.date);
    const currentMonth = new Date(this.txtSearchDate);
    
    // If the month doesn't match the current month view, ignore the click
    if (clickedDate.getMonth() !== currentMonth.getMonth() || 
        clickedDate.getFullYear() !== currentMonth.getFullYear()) {
      return; // Exit without processing the click
    }

    const app = document.getElementById("app");
    const p = document.createElement("h3");
    var d = new Date(arg.date);
    p.textContent = d.getDate().toString();
    $(p).css('color', '#20A2C0')
    var arrDayInWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    let p2 = document.createElement("h4");
    let p3 = document.createElement("hr");

    p2.textContent = arrDayInWeek[d.getDay()];

    $(app).html("");
    $(app).html(p).append(p2).append(p3);


    this.txtSearch = d.getFullYear() + '-' + (d.getMonth() + 1).toString().padStart(2, '0');
    this.txtSearchDate = arg.dateStr;
    this.txtSearchEndDate = "";

    this.LoadPlanningList(false);
  }

  public onDateChanged(event = null) {
    if (event != null) {
      // Format txtSearch to YYYY-MM format
      var d = new Date(event.target.value);
      this.txtSearch = d.getFullYear() + '-' + (d.getMonth() + 1).toString().padStart(2, '0');
      this.txtSearchDate = event.target.value + '-01';
    }
    var d = new Date(this.txtSearchDate);
    var days = new Date(d.getFullYear(), (d.getMonth() + 1), 0).getDate();
    var enddate = d.getFullYear() + '-' + (d.getMonth() + 1).toString().padStart(2, '0') + '-' + days;
    this.txtSearchEndDate = enddate;

    $('#app').html(""); //clear search date
    this.calendarComponent.getApi().gotoDate(this.txtSearchDate)

    // Load planning list
    this.LoadPlanningList(true);
  }

  LoadPlanningList(needLoadNewCalendar: boolean = false) {
    
    this.LoadProjectSalePlanningList().then((data) => {

      this.ProjectSalePlanningList = data;
      if (needLoadNewCalendar) {
        this.strJsonProjectSalePlanningList = JSON.stringify(data);
        this.fullCalendarInitialDate = this.txtSearchDate;
        this.fullcalendarLoadEvent(data);
      }
    });
  }



  async LoadSaleTeam() {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['EmployeeCode'] = this.checkUndefinedString(this._EmpCode);
      objectjson['IgnoreFlagSaleTarget'] = "Y";

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<SaleTeamMappingEmployeeInfo[]>(this.baseurl + "Team/GetEmpMappingTeam", strjson, httpOptions)
        .toPromise().then((data) => {
          this.SaleTeamList = data;
          // if(this.SaleTeamList.length > 0){
          //   this.txtSearchSaleTeam = this.SaleTeamList[0].SaleTeamCode;
          //   this.MyEmployeeNameWithUnder = this.SaleTeamList[0].EmployeeName;
          //   this.LoadSaleTeamUnders();
          // }
        });
    }
  }

  async LoadSaleTeamUnders() {

    this.SaleTeamUnderList = [];

    if(this.txtSearchSaleTeamMember != null && this.txtSearchSaleTeamMember != null && this.txtSearchSaleTeamMember != this._EmpCode){
      this.txtSearchSaleTeamMember = null;
    }

    await this.ChangeEmpPlan();

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['SaleTeamCode'] = this.checkUndefinedString(this.txtSearchSaleTeam);
      objectjson['EmployeesUnder'] = this.checkUndefinedString(this._EmpCode);
      objectjson['AssignedSellerOnly'] = true;
      objectjson['MyEmployeeCodeWithUnder'] = this.checkUndefinedString(this._EmpCode);
      objectjson['MyEmployeeNameWithUnder'] = this.checkUndefinedString(this.MyEmployeeNameWithUnder);

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<SaleTeamMappingEmployeeInfo[]>(this.baseurl + "Team/GetEmpMappingTeam", strjson, httpOptions)
        .toPromise().then((data) => {
          this.SaleTeamUnderList = data
        });
    }
  }

  ChangeEmpPlan(isSelf = false) {
    
    
    if(isSelf){
      //this.txtSearchSaleTeamMember = null;
      this.txtSearchSaleTeamMember = this._EmpCode;
      this.txtSearchSaleTeam = null;
      this.SaleTeamUnderList = [];
    }

    $("#app").html("");
    this.goToMonthView();
  }

  async OnddlSaleTeamCodeChange() {
    //if (this.ddlSaleTeamCode != null && this.ddlSaleTeamCode != '') {
      console.log("OnddlSaleTeamCodeChange");
    await this.LoadProjectSaleList();
    //}
  }

  async LoadPlanType() {
    //console.log('LoadPlanType');
    this.PlanTypeList = [];

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['LookupType'] = "PlanType";

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise().then((data) => {
          this.PlanTypeList = data;
        });
    }
  }

  async OnddlProjectSaleCodeChange() {
    const selectedCode = this.ProjectSalePlanningForm.get('ddlProjectSaleCode')?.value;

  if (!selectedCode) {
    this.ProjectSalePlanningForm.patchValue({ txtPipelineStatusName: null });
    return;
  }

  const objectjson = { ProjectSaleCode: selectedCode };
  const strjson = JSON.stringify(objectjson);

  try {
    const auth_token = await this.TokenService.RefreshToken();

    if (!auth_token) return;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    const result = await this.httpClient
      .post<ProjectPipelineInfo[]>(`${this.baseurl}ProjectPipeline/GetLastestProjectPipeline`, strjson, httpOptions)
      .toPromise();

      //console.log('API response:', result);

    this.pipelineStatusCodeSelected = result?.[0]?.ProjectPipelineStatusLookupCode || '';
    const statusName = result?.[0]?.ProjectPipelineStatusLookupValue || '';
    this.ProjectSalePlanningForm.patchValue({
      txtPipelineStatusName: statusName
    });

  } catch (error) {
    console.error("Failed to fetch pipeline status", error);
    this.ProjectSalePlanningForm.patchValue({
      txtPipelineStatusName: ''
    });
  }

  }

  async GetPipelineStatusName(lookupCode: string): Promise<string> {
  if (!lookupCode) return '';

  try {
    const auth_token = await this.TokenService.RefreshToken();
    if (!auth_token) return '';

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    // สร้าง JSON string
    const requestObject = {
      LookupType: "PIPELINESTATUS",
      LookupCode: lookupCode
    };
    const strjson = JSON.stringify(requestObject);

    const data = await this.httpClient
      .post<LookupInfo[]>(this.baseurl + "Lookup/GetLookupFromLookupCode", strjson, httpOptions)
      .toPromise();

    return data?.[0]?.LookupValue || '';
  } catch (error) {
    console.error("GetPipelineStatusName error:", error);
    return '';
  }
}

  async getAccessToken(account: any): Promise<string> {
  const response = await this.msalService.instance.acquireTokenSilent({
    scopes: [ 'User.Read', "Mail.ReadWrite", "Mail.Send", 'Calendars.ReadWrite', 'OnlineMeetings.ReadWrite'
    ],
    account
  });

  return response.accessToken;
}


  callGraphApi(token: string) {
    const headers = { Authorization: `Bearer ${token}` };

    this.httpClient.get('https://graph.microsoft.com/v1.0/me', { headers })
      .subscribe(user => {
        //console.log('Microsoft Graph /me:', user);
    });
  }

  async createTodayTeamsMeeting0(token: string): Promise<any> {
    //console.log('createTodayTeamsMeeting Clicked!!')
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    const timeZone = "SE Asia Standard Time"; // GMT+7
    const now = new Date();

    // สร้าง Date object สำหรับวันนี้ 15:00 - 16:00
    const startDateTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 15, 0, 0);
    const endDateTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 16, 0, 0);

    const body = {
      subject: "Meeting Today 15:00 - 16:00 GMT+7", // Meeting Title
      start: { dateTime: startDateTime.toISOString(), timeZone },
      end: { dateTime: endDateTime.toISOString(), timeZone },
      isOnlineMeeting: true,
      onlineMeetingProvider: "teamsForBusiness"
    };

    try {
      // ใช้ toPromise() สำหรับ Angular <16
      const response = await this.httpClient.post(
        "https://graph.microsoft.com/v1.0/me/events",
        body,
        { headers }
      ).toPromise();

      //console.log("Teams Meeting created:", response);
      return response;
    } catch (err) {
      console.error("Failed to create Teams meeting:", err);
      throw err;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async createTeamsMeeting(): Promise<string | null> {
    this.statusMessage = null;

    const account = this.msalService.instance.getActiveAccount(); 
    if (!account) {
      console.warn('No active account found! Please log in first.');
      this.statusMessage = 'Please log in first.';
      this.isSuccess = false;
      return;
    }

    try {
      // 1. ขอ Access Token แบบ Silent: MSAL จะตรวจสอบในแคชก่อน
      // ถ้าไม่มี หรือหมดอายุ จะต่ออายุให้อัตโนมัติ (โดยใช้ Refresh Token)
      this.statusMessage = 'กำลังเตรียมสร้างการประชุม กรุณารอสักครู่...';
      
      const tokenResponse = await this.msalService.instance.acquireTokenSilent({
        scopes: ['User.Read', "Mail.ReadWrite", "Mail.Send", 'Calendars.ReadWrite', 'OnlineMeetings.ReadWrite'],
        account: account,
      });

      const token = tokenResponse.accessToken;
      //console.log('Access Token acquired for API call:', token);

      const headers = new HttpHeaders({
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      });

      const timeZone = "SE Asia Standard Time"; // GMT+7
      const now = new Date();      

      const startDateTimeString = this.checkUndefinedDate(this.ProjectSalePlanningForm.get('txtPlanningStartDate').value) + "T" + this.checkUndefinedString(this.ProjectSalePlanningForm.get('txtPlanningStartTime').value) + ":00";
      const endDateTimeString = this.checkUndefinedDate(this.ProjectSalePlanningForm.get('txtPlanningEndDate').value) + "T" + this.checkUndefinedString(this.ProjectSalePlanningForm.get('txtPlanningEndTime').value) + ":00";
      const startDate = this.checkUndefinedDate(this.ProjectSalePlanningForm.get('txtPlanningStartDate').value);
      const endDate = this.checkUndefinedDate(this.ProjectSalePlanningForm.get('txtPlanningEndDate').value);

      //console.log('starttime: ', this.checkUndefinedString(this.ProjectSalePlanningForm.get('txtPlanningStartTime').value));
      //console.log('endtime: ', this.checkUndefinedString(this.ProjectSalePlanningForm.get('txtPlanningEndTime').value));
      //console.log('startDateTimeString', startDateTimeString);
      //console.log('endDateTimeString', endDateTimeString);

      // ใช้ string ที่สร้างขึ้นมาใหม่เพื่อสร้าง Date object
      let startDateTime = new Date(startDateTimeString);
      let endDateTime = new Date(endDateTimeString);

      if (this.checkUndefinedString(this.ProjectSalePlanningForm.get('txtPlanningStartTime').value) === '' && this.checkUndefinedString(this.ProjectSalePlanningForm.get('txtPlanningEndTime').value) === ''){
        startDateTime = new Date(`${startDate}T00:00:00`);
  
        // end = วันถัดไป 00:00 (exclusive)
        const endDateObj = new Date(endDate);
        endDateObj.setDate(endDateObj.getDate() + 1);
        endDateTime = new Date(`${endDateObj.toISOString().split('T')[0]}T00:00:00`);
      }

      const attendeesInput: string = this.ProjectSalePlanningForm.get('AttendeesEmail')?.value || '';
      const attendees = attendeesInput.split(/;|,/)  // แยกด้วย semicolon หรือ comma
      .map(email => email.trim()).filter(email => email !== '').map(email => ({
        emailAddress: { address: email },
        type: 'required'
      }));

      const body = {
        subject: this.ProjectSalePlanningForm.get('txtPlanningSubject').value,
        body: {
          contentType: "HTML",
          content: this.ProjectSalePlanningForm.get('txtDescription')?.value || "สร้างจากระบบ Sale Planning"
        },
        start: { dateTime: startDateTime.toISOString(), timeZone },
        end: { dateTime: endDateTime.toISOString(), timeZone },
        isOnlineMeeting: true,
        onlineMeetingProvider: "teamsForBusiness",
        attendees: attendees
      };

      // ใช้ toPromise() เนื่องจาก HttpClient.post() เป็น Observable
      const response: any = await this.httpClient.post(
        "https://graph.microsoft.com/v1.0/me/events",
        body,
        { headers }
      ).pipe(
        takeUntil(this.destroy$)
      ).toPromise();

      this.hidMeetingID = response.id;
      //console.log("Teams Meeting created successfully! Meeting ID:", this.hidMeetingID);

      // --- Call function Send Email After Create Meeting ---
    await this.sendEmailToActiveAccount(
      body.subject,
      startDateTime.toISOString(),
      endDateTime.toISOString(),
      response.onlineMeeting?.joinUrl || ''
    );

      this.statusMessage = `สร้างการประชุม Teams เรียบร้อยแล้ว! Meeting ID: ${this.hidMeetingID}`;
      this.isSuccess = true;
      return this.hidMeetingID;

    } catch (err: any) {
      console.error("Failed to create Teams meeting:", err);
      this.statusMessage = `เกิดข้อผิดพลาดในการสร้างการประชุม: ${err.message || 'ไม่ทราบสาเหตุ'}`;
      this.isSuccess = false;

      // ถ้าเกิดข้อผิดพลาดที่ต้องให้สิทธิ์เพิ่มเติม
      if (err.name === 'InteractionRequiredAuthError') {
        this.statusMessage = 'กำลังขอสิทธิ์เพิ่มเติม... กรุณาให้ความยินยอมในหน้าถัดไป';
        //console.log("Interactive login required, initiating redirect...");
        this.msalService.loginRedirect({
          scopes: ['User.Read', "Mail.ReadWrite", "Mail.Send", 'Calendars.ReadWrite', 'OnlineMeetings.ReadWrite'],
        });
      }

      return null;
    }
  }

  async updateTeamsMeeting(eventId: string): Promise<string | null> {
  this.statusMessage = null;

  const account = this.msalService.instance.getActiveAccount();
  if (!account) {
    console.warn('No active account found! Please log in first.');
    this.statusMessage = 'Please log in first.';
    this.isSuccess = false;
    return null;
  }

  try {
    this.statusMessage = 'กำลังอัปเดตการประชุม กรุณารอสักครู่...';

    const tokenResponse = await this.msalService.instance.acquireTokenSilent({
      scopes: ['Calendars.ReadWrite', "Mail.ReadWrite", "Mail.Send", "OnlineMeetings.ReadWrite"],
      account: account,
    });
    const token = tokenResponse.accessToken;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    const timeZone = "SE Asia Standard Time";

    // ดึงค่าจากฟอร์ม
    const startDateTimeString = this.checkUndefinedDate(this.ProjectSalePlanningForm.get('txtPlanningStartDate').value) + "T" + this.checkUndefinedString(this.ProjectSalePlanningForm.get('txtPlanningStartTime').value) + ":00";
    const endDateTimeString = this.checkUndefinedDate(this.ProjectSalePlanningForm.get('txtPlanningEndDate').value) + "T" + this.checkUndefinedString(this.ProjectSalePlanningForm.get('txtPlanningEndTime').value) + ":00";
    const startDate = this.checkUndefinedDate(this.ProjectSalePlanningForm.get('txtPlanningStartDate').value);
    const endDate = this.checkUndefinedDate(this.ProjectSalePlanningForm.get('txtPlanningEndDate').value);

    //console.log('starttime: ', this.checkUndefinedString(this.ProjectSalePlanningForm.get('txtPlanningStartTime').value));
    //console.log('endtime: ', this.checkUndefinedString(this.ProjectSalePlanningForm.get('txtPlanningEndTime').value));
    //console.log('startDateTimeString', startDateTimeString);
    //console.log('endDateTimeString', endDateTimeString);

    // สร้าง datetime string
    let startDateTime = new Date(startDateTimeString);
    let endDateTime = new Date(endDateTimeString);

    if (this.checkUndefinedString(this.ProjectSalePlanningForm.get('txtPlanningStartTime').value) === '' && this.checkUndefinedString(this.ProjectSalePlanningForm.get('txtPlanningEndTime').value) === ''){
      startDateTime = new Date(`${startDate}T00:00:00`);
  
      // end = วันถัดไป 00:00 (exclusive)
      const endDateObj = new Date(endDate);
      endDateObj.setDate(endDateObj.getDate() + 1);
      endDateTime = new Date(`${endDateObj.toISOString().split('T')[0]}T00:00:00`);
    }

    const attendeesRaw = this.ProjectSalePlanningForm.get('AttendeesEmail')?.value || '';
    const attendees = attendeesRaw
      .split(/;|,/)
      .map((email: string) => email.trim())
      .filter((email: string) => email.length > 0) // ตัดช่องว่าง/empty ออก
      .map((email: string) => ({
        emailAddress: { address: email },
        type: "required"
      }));

    const body = {
      subject: this.ProjectSalePlanningForm.get('txtPlanningSubject')?.value,
      body: {
          contentType: "HTML",
          content: this.checkUndefinedString(this.txtDescription) || "สร้างจากระบบ Sale Planning"
        },
      start: { dateTime: startDateTime.toISOString(), timeZone },
      end: { dateTime: endDateTime.toISOString(), timeZone },
      isOnlineMeeting: true,
      onlineMeetingProvider: "teamsForBusiness",
      attendees: attendees
    };

    const response: any = await this.httpClient.patch(
      `https://graph.microsoft.com/v1.0/me/events/${eventId}`,
      body,
      { headers }
    ).pipe(takeUntil(this.destroy$)).toPromise();

    //console.log(`Updated Teams Meeting: ${eventId}`);
    this.statusMessage = `อัปเดตการประชุมเรียบร้อยแล้ว (Meeting ID: ${eventId})`;
    this.isSuccess = true;

    // Call function Send Email After Update Meeting
    await this.sendEmailToActiveAccount(
      body.subject,
      startDateTime.toISOString(),
      endDateTime.toISOString(),
      response?.onlineMeeting?.joinUrl || '' // ถ้ามี joinUrl จะส่งไปด้วย
    );

    return eventId;

  } catch (err: any) {
    console.error("Failed to update Teams meeting:", err);
    this.statusMessage = `เกิดข้อผิดพลาดในการอัปเดต: ${err.message || 'ไม่ทราบสาเหตุ'}`;
    this.isSuccess = false;
    return null;
  }
}

  async deleteTeamsMeeting(eventId: string): Promise<void> {  
  // รอ การสร้าง field meetingid ใน table ProjectSaleplanning เพ่ื่อเก็บ MeetingID แต่ละ Meeting บน UI 
  this.statusMessage = null;

  const account = this.msalService.instance.getActiveAccount();
  if (!account) {
    console.warn('No active account found! Please log in first.');
    this.statusMessage = 'Please log in first.';
    this.isSuccess = false;
    return;
  }

  try {
    // ขอ Access Token แบบ Silent
    const tokenResponse = await this.msalService.instance.acquireTokenSilent({
      scopes: ['Calendars.ReadWrite', "Mail.ReadWrite", "Mail.Send", "OnlineMeetings.ReadWrite"],
      account: account,
    });
    const token = tokenResponse.accessToken;
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });

    // เรียก Microsoft Graph API ลบ Event
    await this.httpClient.delete(
      `https://graph.microsoft.com/v1.0/me/events/${eventId}`,
      { headers }
    ).pipe(takeUntil(this.destroy$)).toPromise();

    //console.log(`Deleted Teams Meeting: ${eventId}`);
    //this.statusMessage = `ลบการประชุมเรียบร้อยแล้ว (Meeting ID: ${eventId})`;
    this.isSuccess = true;

    // Call function Send Email After Delete Meeting
    await this.sendEmailToActiveAccount(
      "Teams Meeting ถูกลบแล้ว", // subject
      new Date().toISOString(),   // ใช้เวลาปัจจุบันเป็น reference
      new Date().toISOString(),
      "" // ไม่มี joinUrl เพราะถูกลบแล้ว
    );

  } catch (err: any) {
    console.error("Failed to delete Teams meeting:", err);
    this.statusMessage = `เกิดข้อผิดพลาดในการลบ: ${err.message || 'ไม่ทราบสาเหตุ'}`;
    this.isSuccess = false;
  }
  }

  async sendEmailToActiveAccount(
  subject: string,
  startDateTime: string,
  endDateTime: string,
  joinUrl: string
): Promise<void> {
  const account = this.msalService.instance.getActiveAccount();
  if (!account) return;

  const tokenResponse = await this.msalService.instance.acquireTokenSilent({
    scopes: ['User.Read', 'Mail.Send', 'Mail.ReadWrite'],
    account: account,
  });
  const token = tokenResponse.accessToken;

  const headers = new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'
  });

  const emailBody = {
    message: {
      subject: `รายละเอียดการประชุม: ${subject}`,
      body: {
        contentType: "HTML",
        content: `
          สวัสดี,<br>
          คุณได้สร้าง Teams Meeting แล้ว<br>
          <b>หัวข้อ:</b> ${subject}<br>
          <b>เริ่ม:</b> ${startDateTime}<br>
          <b>สิ้นสุด:</b> ${endDateTime}<br>
          <b>ลิงก์ Teams:</b> <a href="${joinUrl}">${joinUrl}</a>
        `
      },
      toRecipients: [{ emailAddress: { address: account.username } }]
    },
    saveToSentItems: true
  };

  await this.httpClient.post("https://graph.microsoft.com/v1.0/me/sendMail", emailBody).toPromise();
}

  async LoadEmployeeList() {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }
      //console.log('currentPageNumberEmployee', this.currentPageNumberEmployee);
      //console.log('environment.PageSize', environment.PageSize);

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {
        rowFetch: environment.PageSize,
        rowOFFSet: ((this.currentPageNumberEmployee - 1) < 0 ? 0 : (this.currentPageNumberEmployee - 1)) * environment.PageSize
      };

      const response = await this.httpClient.post<any>(this.baseurl + "Employee/GetEmployeeModal", JSON.stringify(objectjson), httpOptions).toPromise();

      this.EmployeeList = response;
      this.totalItems = this.EmployeeList.length;

      if (this.EmployeeList.length <= 0) {
        this.currentPageNumberEmployee = 0;
      } else {
        if (this.currentPageNumberEmployee == 0) this.currentPageNumberEmployee = 1;
        this.totalItems = Number(this.EmployeeList[0].countEmp);
      }

      this.totalPagesEmployee = Math.ceil(this.totalItems / environment.PageSize);
    } catch (error) {
      console.error('Error loading employee:', error);
      alert('An error occurred while loading employee data. Please try again.');
    } finally {
      //
    }
  }

  OnLoadEmployee(target = null) {

  //console.log('Callback target:', target);

    if (target != null) {
      this.currentPageNumberEmployee = target.currentPageNumber;
      this.totalPagesEmployee = target.totalPages;
    }

    //console.log('OnLoadCompanyListV2 currentPageNumber:', this.currentPageNumber);
    //console.log('OnLoadCompanyListV2 totalPages:', this.totalPages);

    this.LoadEmployeeList();
  }

  async OnclickAddAttendeesEmail() {
    const checkboxes = document.querySelectorAll<HTMLInputElement>('input[name="checkboxEmployee"]');
    checkboxes.forEach(cb => cb.checked = false);

    if (this.chkAllEmployee) {
      this.chkAllEmployee.nativeElement.checked = false;
    }

    $('#modalAddAttendeesEmail').modal('show');
  }

  chkallAttendeesEmailclick(target) {
    var check = $(target.currentTarget).is(":checked");

    $('[name="checkboxEmployee"]').prop('checked', check);

  }

  btnClick_submitAddAttendeesEmail(): void {
      const checkboxes = document.querySelectorAll<HTMLInputElement>(
      'input[name="checkboxEmployee"]:checked'
    );

    const selectedIds = Array.from(checkboxes).map(cb => parseInt(cb.value, 10));
    const selectedEmails = this.EmployeeList.filter(emp => selectedIds.includes(emp.Id)).map(emp => emp.Mail);
    const emailsToAdd = selectedEmails.join(';') + (selectedEmails.length > 0 ? ';' : '');

    //console.log('Selected Emails:', emailsToAdd);
    const currentValue = this.ProjectSalePlanningForm.get('AttendeesEmail')?.value || '';
    const trimmedCurrent = currentValue.trim();

    const endsWithSeparator = trimmedCurrent.endsWith(';') || trimmedCurrent.endsWith(',');

    //const newValue = currentValue + emailsToAdd;
    const newValue = trimmedCurrent === ''
    ? emailsToAdd
    : (endsWithSeparator ? trimmedCurrent : trimmedCurrent + ';') + emailsToAdd;
    this.ProjectSalePlanningForm.get('AttendeesEmail')?.setValue(newValue);

    $('#modalAddAttendeesEmail').modal('hide');
  }

  async MicrosoftTeamSync() {
    const account = this.msalService.instance.getActiveAccount();
    this.IsHasMSAccount = !!account;
  if (!account) {
    //console.log("No Microsoft account found, redirecting to login...");
    const confirmLogin = window.confirm("คุณต้องการ login Microsoft เพื่อสร้างหรือเปลี่ยนแปลงในการจัดการ Microsoft Teams Meeting หรือไม่?");

    if (confirmLogin) {
      this.msalService.loginRedirect({
      scopes: ['User.Read', "Mail.ReadWrite", "Mail.Send", 'Calendars.ReadWrite', 'OnlineMeetings.ReadWrite'],
      prompt: 'login'
    });
      return; // ยังไม่ให้เปิด modal จนกว่าจะ login
    } else {
      //console.log("User chose not to login Microsoft");
    }
  }

  //console.log("Microsoft account found:", account);
  if (account != null) {
    //console.log('Continue code');
    try {
      const tokenResponse = await this.msalService.instance.acquireTokenSilent({
        scopes: ['User.Read', 'Mail.ReadWrite', 'Mail.Send', 'Calendars.ReadWrite', 'OnlineMeetings.ReadWrite'],
        account: account
      });

      const token = tokenResponse.accessToken;

      const headers = new HttpHeaders({
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Prefer': 'outlook.timezone="Asia/Bangkok"'
      });

      const now = new Date();
      const startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1, 0, 0, 0, 0); // 1 เดือนก่อนวันนี้
      const endDate = new Date(now.getFullYear(), 11, 31, 23, 59, 59, 999); // 31 ธ.ค.

        const startDateISO = startDate.toISOString();
        const endDateISO = endDate.toISOString();

        let nextUrl = `https://graph.microsoft.com/v1.0/me/calendarView?startDateTime=${startDateISO}&endDateTime=${endDateISO}&$orderby=start/dateTime desc`;
        let allEvents: any[] = [];

        let page = 1;
        while (nextUrl) {
          const response: any = await this.httpClient.get(nextUrl, { headers }).toPromise();
          if (response?.value?.length) {
            allEvents = allEvents.concat(response.value);
          }
          nextUrl = response['@odata.nextLink'] || null;
          page++;
        }

      //console.log(`Total Events Fetched: ${allEvents.length}`);

      //   const calendarViewUrl = `https://graph.microsoft.com/v1.0/me/calendarView?startDateTime=${startDateISO}&endDateTime=${endDateISO}`;

      // // เรียก Microsoft Graph API เพื่อดึง calendar events (ที่เป็น online meeting)
      // const response: any = await this.httpClient.get(
      //   //'https://graph.microsoft.com/v1.0/me/events?$orderby=start/dateTime desc&$top=50',
      //   calendarViewUrl,
      //   { headers }
      // ).toPromise();

      //const events = response.value as any[];

      const meetings: Partial<ProjectSalePlanningInfo>[] = allEvents
        //.filter(e => !!e.onlineMeeting || !!e.onlineMeetingUrl)
        .map(e => ({
          MeetingTeamID: e.id,
          Subject: e.subject,
          StartDate: this.formatDateTimeForDb(e.start?.dateTime),
          EndDate: this.formatDateTimeForDb(e.end?.dateTime),
          AttendeesEmailList: e.attendees?.map((a: any) => a.emailAddress?.address) || [],
          Description: this.extractCleanDescription(e.body?.content || ''),
          MicrosoftAccount: account.username,
          CreateBy: this._EmpCode
        }));

      //console.log('EmpCodeLogin:', this._EmpCode);
      //console.log("Microsoft account used:", account.username);
      //console.log("Synced Meetings:", meetings);

      // Optional: ส่งข้อมูลไป backend API ของคุณ
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      this.httpClient.post<boolean>(this.baseurl + "ProjectSalePlanning/SyncMicrosoftTeamProjectSalePlanningList", meetings, httpOptions)
        .toPromise().then((isSuccess) => {
          if (isSuccess) {
            //console.log("Sync Microsoft Teams Meetings:", isSuccess ? "Success" : "Failed");
            $('#ModalUpdateComplate').modal();
            this.ngOnInit();
          }
        })
        .catch((err) => {
          console.error("Error calling backend API:", err);
        });
    }

    } catch (err: any) {
      console.error('Error syncing meetings:', err);
      alert('เกิดข้อผิดพลาดในการ sync meetings: ' + (err.message || 'ไม่ทราบสาเหตุ'));
    }
    
  } else {
    console.log('No continue code');
  }
  }

  formatDateTimeForDb(dateTimeStr?: string): string {
    if (!dateTimeStr) return '';

    const parts = dateTimeStr.split('.');

    if (parts.length < 2) {
      // กรณีไม่มีจุดทศนิยม เช่น "2025-10-07T01:30:00"
      return dateTimeStr.replace('T', ' ');
    }

    const milliseconds = parts[1].substring(0, 3); // ตัด 3 ตำแหน่งทศนิยมแรก
    const trimmed = `${parts[0]}.${milliseconds}`;

    return trimmed.replace('T', ' ');
  }

  private extractCleanDescription(htmlContent: string): string {
    if (!htmlContent) return '';

    const div = document.createElement('div');
    div.innerHTML = htmlContent;
    const fullText = div.innerText || div.textContent || '';

    const lines = fullText.split('\n').map(line => line.trim()).filter(line => !!line);
    const ignoredPatterns = [
      'Microsoft Teams',
      'Join the meeting now',
      'Join', // เพิ่มตรงนี้ เพื่อกรองคำว่า "Join" อย่างเดียวด้วย
      'Meeting ID:',
      'Passcode:',
      'Meeting options',
      'Need help?',
      'For organizers:',
      '________________________________________________________________________________'
    ];

    const filteredLines = lines.filter(line =>
      !ignoredPatterns.some(pattern => line.includes(pattern))
    );

    return filteredLines.slice(0, 1)[0] || ''; // เอาเฉพาะบรรทัดแรกสุดที่เหลือ
  }



  /*********************************************************/
}
